const initialState = window.__STATE__.stripe || {};

export default function reducer(state = initialState, action) {
  return state
}
